<template>
  <div class="about-page">
    <div class="content-section">
      <!-- 页面标题 -->
      <div class="page-header">
        <h1>About MethArDB</h1>
        <div class="header-underline"></div>
      </div>

      <!-- 数据库介绍 -->
      <section class="about-section">
        <h2>Database Introduction</h2>
        <p>
          MethArDB (Methanogenic Archaea Database) is a comprehensive web-based platform dedicated to methanogenic archaea genomics research. 
          Our database integrates genome sequences, plasmid data, and virus information with powerful bioinformatics analysis tools. 
          The platform provides researchers with easy access to curated genomic data and specialized analytical capabilities for studying 
          methanogenic archaea, including genome annotation, comparative genomics, and metabolic pathway analysis.
        </p>
        <p>
          The database features an intuitive web interface that allows users to search, browse, and download genomic data, 
          as well as perform various bioinformatics analyses online. MethArDB serves as a valuable resource for researchers 
          working in the fields of microbiology, environmental science, and biotechnology.
        </p>
      </section>

      <!-- 数据来源 -->
      <section class="about-section">
        <h2>Data Source</h2>
        <p>
          The genomic data in MethArDB is sourced from NCBI RefSeq and GenBank databases. 
          We regularly update our database to ensure that researchers have access to the 
          most current and comprehensive collection of methanogenic archaea genomic data.
        </p>
        <div class="data-stats">
          <div class="stat-card">
            <h3>Genome</h3>
            <p></p>
          </div>
          <div class="stat-card">
            <h3>Plasmid</h3>
            <p></p>
          </div>
          <div class="stat-card">
            <h3>virus</h3>
            <p></p>
          </div>
        </div>
      </section>

      <!-- 团队信息 -->
      <section class="about-section">
        <h2>Research Team</h2>
        <p>
          MethArDB is developed and maintained by the research team at College of Biotechnology and Pharmaceutical Engineering, Nanjing Tech University and College of Chemistry and Chemical Engineering, 
          Xiamen University. Our team is dedicated to providing high-quality genomic data and analysis tools for the research community.
        </p>
        
        <!-- 团队图片 -->
        <div class="team-image">
          <img src="/images/team-photo.jpg" alt="Research Team" class="team-photo" />
        </div>
        
        <div class="team-info">
          <div class="info-card">
            <h3>Development Team</h3>
            <p>College of Biotechnology and Pharmaceutical Engineering,</p>
            <p>Nanjing Tech University</p>
            <p>College of Chemistry and Chemical Engineering,</p>
            <p>Xiamen University</p>
          </div>
          <div class="info-card">
            <h3>Contact Information</h3>
            <p>Prof. Jun Zhou e-mail: zhoujun@njtech.edu.cn</p>
            <p>Prof. Yuanpeng Wang e-mail: wypp@xmu.edu.cn</p>
          </div>
        </div>
      </section>

      <!-- 引用信息 -->
      <section class="about-section">
        <h2>Citation</h2>
        <p>
          If you use MethArDB in your research, please cite our database as follows:
        </p>
        <div class="citation-box">
          <p>
            [Citation information will be updated upon publication]
          </p>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AboutPage'
}
</script>

<style scoped>
.about-page {
  padding: 20px;
  max-width: 1280px;
  margin: 0 auto;
}

.content-section {
  margin-top: 77px;
  background: white;
  border-radius: 12px;
  padding: 40px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.page-header {
  text-align: center;
  margin-bottom: 40px;
}

.page-header h1 {
  font-size: 2.5rem;
  color: #1a1a1a;
  margin-bottom: 16px;
}

.header-underline {
  width: 60px;
  height: 3px;
  background: #4169E1;
  margin: 0 auto;
  border-radius: 2px;
}

.about-section {
  margin-bottom: 40px;
}

.about-section h2 {
  font-size: 1.8rem;
  color: #2c3e50;
  margin-bottom: 20px;
  position: relative;
  padding-bottom: 10px;
}

.about-section h2::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 40px;
  height: 2px;
  background: #4169E1;
}

.about-section p {
  font-size: 1.1rem;
  line-height: 1.6;
  color: #4a5568;
  margin-bottom: 20px;
}

.data-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-top: 30px;
}

.stat-card {
  background: #f8fafc;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
}

.stat-card h3 {
  font-size: 1.1rem;
  color: #4a5568;
  margin-bottom: 10px;
}

.stat-card p {
  font-size: 1.8rem;
  color: #2c3e50;
  font-weight: 600;
  margin: 0;
}

.team-info {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-top: 30px;
}

.info-card {
  background: #f8fafc;
  padding: 20px;
  border-radius: 8px;
}

.info-card h3 {
  font-size: 1.2rem;
  color: #2c3e50;
  margin-bottom: 15px;
}

.info-card p {
  font-size: 1rem;
  color: #4a5568;
  margin: 5px 0;
}

.citation-box {
  background: #f8fafc;
  padding: 20px;
  border-radius: 8px;
  border-left: 4px solid #4169E1;
}

.citation-box p {
  font-family: 'Consolas', monospace;
  font-size: 0.9rem;
  margin: 0;
  white-space: pre-wrap;
  word-break: break-word;
}

/* 团队图片样式 */
.team-image {
  text-align: center;
  margin: 30px 0;
}

.team-photo {
  max-width: 100%;
  height: auto;
  max-height: 400px;
}

.institute-link {
  color: #4169E1;
  text-decoration: none;
  transition: all 0.3s;
  font-weight: normal;
}

.institute-link:hover {
  color: #1d4ed8;
  font-weight: bold;
  text-decoration: none;
}

@media (max-width: 768px) {
  .content-section {
    padding: 20px;
  }

  .page-header h1 {
    font-size: 2rem;
  }

  .data-stats,
  .team-info {
    grid-template-columns: 1fr;
  }

  .about-section h2 {
    font-size: 1.5rem;
  }

  .about-section p {
    font-size: 1rem;
  }
}
</style>